export const FETCH_BULK_LABEL_DOWNLOAD_SUCCESS = 'FETCH_BULK_LABEL_DOWNLOAD_SUCCESS';
export const FETCH_BULK_LABEL_DOWNLOAD_REQUEST = 'FETCH_BULK_LABEL_DOWNLOAD_REQUEST';
export const FETCH_BULK_LABEL_DOWNLOAD_FAILURE = 'FETCH_BULK_LABEL_DOWNLOAD_FAILURE';
export const FETCH_BULK_LABEL_DOWNLOAD_REST = 'FETCH_BULK_LABEL_DOWNLOAD_REST';
export const fetchBulkLabelDownloadSuccess = (payload) => ({
    type: FETCH_BULK_LABEL_DOWNLOAD_SUCCESS,
    payload,
});
export const fetchBulkLabelDownloadRequest = (payload) => ({
    type: FETCH_BULK_LABEL_DOWNLOAD_REQUEST,
    payload,
});
export const fetchBulkLabelDownloadFailure = (payload) => ({
    type: FETCH_BULK_LABEL_DOWNLOAD_FAILURE,
    payload,
});
export const fetchBulkLabelDownloadReset = () => ({
    type: FETCH_BULK_LABEL_DOWNLOAD_REST,
});
